module.exports = __webpack_public_path__ + "img/map_img.cc4fde57.png";